export const labels = {
	ErrorUnsupportedFileTypeAll: {
		// description: this dialog is shown when all of the photos which the user is trying to upload have an invalid file type
		title: {
			label: "Label.MobileCreator.ErrorUnsupportedFileTypeAll.title",
			default: "Unsupported file type",
		},
		message: {
			label: "Label.MobileCreator.ErrorUnsupportedFileTypeAll.message",
			default: "You can only upload photos jpg, png or heic files.",
		},
		ok: {
			label: "Label.MobileCreator.ErrorUnsupportedFileTypeAll.ok",
			default: "Ok",
		},
	},
	ErrorUnsupportedFileSize: {
		// description: this dialog is shown when some of the photos which the user is trying to upload have a too large file size
		title: {
			label: "Label.MobileCreator.ErrorUnsupportedFileSize.title",
			default: "File size too big",
		},
		message: {
			label: "Label.MobileCreator.ErrorUnsupportedFileSize.message",
			default: "The following {0} photo(s) failed to upload, file size too big: {1}",
			// 0: amount of invalid photos
			// 1: comma seperated list of filenames of files which are too big to upload
		},
		ok: {
			label: "Label.MobileCreator.ErrorUnsupportedFileSize.ok",
			default: "Ok",
		},
	},
	ErrorUnsupportedFileType: {
		// description: this dialog is shown when some of the photos which the user is trying to upload have an invalid file type
		title: {
			label: "Label.MobileCreator.ErrorUnsupportedFileType.title",
			default: "Unsupported file type",
		},
		message: {
			label: "Label.MobileCreator.ErrorUnsupportedFileType.message",
			default:
				"You can only upload photos jpg, png or heic files. Only {0} of {1} photos will be uploaded.",
			// 0: amount of valid photos which will be uploaded
			// 1: total amount of photos the user is trying to upload
		},
		ok: {
			label: "Label.MobileCreator.ErrorUnsupportedFileType.ok",
			default: "Ok",
		},
	},
	ErrorPhotosFailed: {
		// description: this dialog is shown when some of the photos which the user is trying to upload aren't supported for various reasons
		title: {
			label: "Label.MobileCreator.ErrorPhotosFailed.title",
			default: "Some photos failed to upload",
		},
		message: {
			label: "Label.MobileCreator.ErrorPhotosFailed.message",
			default: "The following {0} photo(s) failed to upload: {1}",
			// 0: amount of invalid photos
			// 1: comma seperated list of filenames of files which are too big to upload
		},
		ok: {
			label: "Label.MobileCreator.ErrorPhotosFailed.ok",
			default: "Ok",
		},
	},
};
